export default "__VITE_ASSET__DBt_nvk4__"